jQuery(document).ready(function($) {
    reload_tooltips();
});
function reload_tooltips() {
    $ = jQuery.noConflict();
    $(".help-tooltip").each(function(){
        //$(this).tooltip("disable");
        $(this).tooltip();
    });
}